import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class BankInfoAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'BankInfos';
   /**
   * Thực hiện lấy danh sách tài khoản đã phát sinh số liệu
   * @param {*} param 
   * PTTAM2 06/06/2023
   */
  async getAriseBankInfo(param) {

    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + '/dataAraise',
      data: param
      
    };

    return await httpClient.postAsync(request);
  }

  /**
   * Thực hiện update tài khoản mở tại kho bạc
   * @param {*} ids Danh sách id cần cập nhật
   * ndthien 7/12/2023 
   */
  async updateOpenInBudget(ids, field = "open_in_budget", value= "true"){
    let apiUrl = this.getAPIUrl();
  
    let request = {
      url: apiUrl + `/openInBudget?field=${field}&value=${value}`,
      data: ids
    };

    return await httpClient.postAsync(request);
  }
}

export default new BankInfoAPI();
